<template>
  <v-container fill-height fluid class="d-flex justify-center align-stretch">
    <p v-if="user === null" class="infos-label">Cargando...</p>
    <p v-if="user && !user.email" class="infos-label">
      No existen Información de usuario
    </p>
    <template v-else>
      <div class="text-center col-lg-3 col-md-3 col-sm-12">
        <v-avatar size="200">
          <img :src="user.photoURL" alt="profilePhoto" />
        </v-avatar>
        <br />
        <label>{{ user.displayName }}</label>
      </div>
      <div id="contact-information" class="col-lg-4 col-md-5">
        <v-input :messages="['Correo']" prepend-icon="mdi-email">
          {{ user.email }}
        </v-input>
        <v-input :messages="['Teléfono']" prepend-icon="mdi-phone">
          <template v-slot:append>
            <ValidPhoneNumber></ValidPhoneNumber>
          </template>
          {{ user.phone ? user.phone : 'No hay información' }}
        </v-input>
      </div>
    </template>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import ValidPhoneNumber from '@/components/normal/ValidPhoneNumber.vue'

export default {
  components: { ValidPhoneNumber },
  computed: {
    ...mapGetters('authentication', ['isUserLoggedIn']),
    ...mapState('authentication', ['user']),
    ...mapState('app', ['networkOnLine', 'appTitle', 'appShortTitle'])
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
@import '@/theme/variables.scss';

.infos-label {
  text-align: center;
}
</style>
